function NavIcon({
  children,
  text = defaultValues.text,
  buttonFunction = defaultValues.buttonFunction,
  buttonArguments = defaultValues.buttonArguments,
  divClass = defaultValues.divClass
}) {
  return (
    <div className={divClass} onClick={() => buttonFunction(buttonArguments)}>
        <button className="navIcon">
            {children}
        </button>
        <br />
        <label className="navLabelIcon" style={{color: '#FFFFFF'}}>{text}</label>
    </div>
  )
}

const emptyFunction = () => {}

const defaultValues = {
  text: 'Placeholder',
  buttonFunction: emptyFunction,
  buttonArguments: '',
  divClass: ''
}

export default NavIcon